import styled from 'styled-components';
import { colors } from '@keen.io/colors';

const Title = styled.div`
  font-family: 'Gangster Grotesk Bold', sans-serif;
  font-size: 20px;
  color: ${colors.black[400]};
`;

export default Title;
